import { instance } from "../api/axiosInstance";
const axiosInstance = instance;

export function getUserId() {
  return (
    window.localStorage.getItem("userId") ||
    window.sessionStorage.getItem("userId")
  );
}

export const setUserLocation = async (latitude, longitude, radius, cityId) => {
  return axiosInstance.patch(`/users/${getUserId()}/setLocation`, {
    latitude,
    longitude,
    radius,
    cityId
  });
};
